/** @jsx isolateComponent */
import { Button, Colors, Img, Link, Spacer, Surface, Text, Typography, } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';
const Styles = {
    bottomLinkSpan: {
        margin: '30px auto',
        display: 'flex',
        'align-items': 'center',
        'text-align': 'center',
    },
    bottomLink: Object.assign(Object.assign({}, Typography.paragraph3Medium), { margin: '0px auto', color: Colors.blueJeans, display: 'flex', 'align-items': 'center', 'text-align': 'center', 'text-decoration-line': 'underline' }),
    ctaBlock: {
        display: 'flex',
        margin: '0px auto',
        'padding-bottom': '40px',
        'padding-top': '35px',
        'flex-direction': 'column',
        'justify-content': 'center',
        'align-items': 'center',
        'text-align': 'center',
        'max-width': '525px',
    },
};
/**
  Generic version of the CTA created initially for the "Upgrade for better support" CTA
*/
const CallToActionBlock = ({ onClickCtaButton, onKeyDownCtaButton, onClickBottomLink, onKeyDownBottomLink, backgroundColor, ctaTitleText, ctaDetailText, ctaButtonText, ctaHeaderImage, ctaHeaderImageAlt, bottomLinkText, ctaButtonClickUrl, bottomLinkUrl, }) => (isolateComponent("div", null,
    isolateComponent(Surface, { backgroundColor: backgroundColor || 'neutral100' },
        isolateComponent(Img, { alt: ctaHeaderImageAlt, isFullWidth: true, src: ctaHeaderImage }),
        isolateComponent("div", { style: Styles.ctaBlock },
            isolateComponent(Text, { color: "neutral800", tag: "h3", textAlign: "center", type: "pageHeader7" }, ctaTitleText),
            isolateComponent(Spacer, { height: 20 }),
            isolateComponent(Text, { color: "neutral700", tag: "p", textAlign: "center", type: "paragraph3" }, ctaDetailText),
            isolateComponent(Spacer, { height: 35 }),
            isolateComponent(Button, { color: "primary", href: ctaButtonClickUrl, onClick: onClickCtaButton, onKeyDown: onKeyDownCtaButton }, ctaButtonText))),
    isolateComponent("span", { style: Styles.bottomLinkSpan },
        isolateComponent(Link, { href: bottomLinkUrl, onClick: onClickBottomLink, onKeyDown: onKeyDownBottomLink, style: Styles.bottomLink, target: "_blank" }, bottomLinkText))));
export default CallToActionBlock;
